import React, { useState } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
// import dayjs from 'dayjs';
import { Car } from 'providers/CarManagmentProvider';

interface AddMaintenanceModalProps {
  show: boolean;
  car: Car | null;
  onHide: () => void;
  onAdd: (event: {
    stateId: number;
    startDate: Date;
    endDate: Date | null;
    observation: string;
    local: string;
  }) => Promise<void>;
}

const AddMaintenanceModal: React.FC<AddMaintenanceModalProps> = ({
  show,
  car,
  onHide,
  onAdd
}) => {
  const [startDay, setStartDay] = useState<Date>(new Date());
  const [endDay, setEndDay] = useState<Date>(new Date());
  const [startTime, setStartTime] = useState<string>('09:00');
  const [endTime, setEndTime] = useState<string>('18:00');
  const [hasEndDate, setHasEndDate] = useState<boolean>(false);
  const [stateId, setStateId] = useState<number>(3);
  const [observation, setObservation] = useState<string>('');
  const [local, setLocal] = useState<string>('');

  const handleAdd = async () => {
    if (!car || stateId === undefined) {
      alert('Intervenção e data de início são obrigatórios.');
      return;
    }

    const [startHour, startMin] = startTime.split(':').map(Number);
    const startDateTime = new Date(startDay);
    startDateTime.setHours(startHour, startMin, 0, 0);

    let endDateTime = null;
    if (hasEndDate) {
      const [endHour, endMin] = endTime.split(':').map(Number);
      endDateTime = new Date(endDay);
      endDateTime.setHours(endHour, endMin, 0, 0);
    }

    await onAdd({
      stateId,
      startDate: startDateTime,
      endDate: endDateTime,
      observation,
      local
    });
  };

  const handleHide = () => {
    setStartDay(new Date());
    setEndDay(new Date());
    setStartTime('09:00');
    setEndTime('18:00');
    setHasEndDate(false);
    setStateId(3);
    setObservation('');
    setLocal('');
    onHide();
  };

  const customStyles = `
    .end-date-container {
      overflow: hidden;
      max-height: 0;
      opacity: 0;
      visibility: hidden;
      transition: max-height 0.3s ease-out, opacity 0.2s ease-out;
    }

    .end-date-container.show {
      max-height: 200px;
      opacity: 1;
      visibility: visible;
      margin-bottom: 1rem;
    }

    .form-label {
      margin-bottom: 0.5rem;
    }
  `;

  return (
    <Modal
      show={show}
      onHide={handleHide}
      contentClassName="border-translucent"
      centered
    >
      <style>{customStyles}</style>
      <Modal.Header className="px-card border-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0">Adicionar Intervenção</Modal.Title>
          <Button className="p-1 fs-10 text-body" onClick={handleHide}>
            X
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body className="p-card py-0">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Intervenção</Form.Label>
            <Form.Select
              value={stateId}
              onChange={e => setStateId(Number(e.target.value))}
            >
              <option value={3}>Avaria</option>
              <option value={4}>Manutenção</option>
              <option value={5}>Inspeção</option>
              <option value={6}>Acidente</option>
            </Form.Select>
          </Form.Group>

          {/* Start Date and Time Row */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Data de Início</Form.Label>
                <DatePicker
                  value={startDay}
                  options={{
                    dateFormat: 'Y-m-d',
                    enableTime: false
                  }}
                  onChange={([date]) => date && setStartDay(date)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Hora de Início</Form.Label>
                <Form.Control
                  type="time"
                  value={startTime}
                  onChange={e => setStartTime(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="mb-3">
            <Form.Check
              type="switch"
              id="has-end-date"
              label="Definir data de fim"
              checked={hasEndDate}
              onChange={event => setHasEndDate(event.target.checked)}
            />
          </div>

          {/* End Date and Time Row - with slide animation */}
          <div className={`end-date-container ${hasEndDate ? 'show' : ''}`}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Data de Fim</Form.Label>
                  <DatePicker
                    value={endDay}
                    options={{
                      dateFormat: 'Y-m-d',
                      enableTime: false
                    }}
                    onChange={([date]) => date && setEndDay(date)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Hora de Fim</Form.Label>
                  <Form.Control
                    type="time"
                    value={endTime}
                    onChange={e => setEndTime(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Observações (Opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={observation}
              onChange={e => setObservation(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Local</Form.Label>
            <Form.Control
              type="text"
              value={local}
              onChange={e => setLocal(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end border-0">
        <Button variant="primary" onClick={handleAdd}>
          Adicionar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMaintenanceModal;
